module.exports = __webpack_public_path__ + "static/media/015.21e83df3.jpg";